import React, { useContext, useState } from 'react';
import Button from '@material-ui/core/Button';
import { Form, FormInput } from '../core/Formikfy';
import { Alert } from '@material-ui/lab';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import Link from '@material-ui/core/Link';
import Avatar from '@material-ui/core/Avatar';
import LockOutlinedIcon from '@material-ui/icons/LockOutlined';
import { AuthContext, useAuth } from '../contexts/AuthContext';
import * as Yup from 'yup';
import { Card } from '../components/Card/Card';
import { CardHeader } from '../components/Card/CardHeader';
import { CardBody } from '../components/Card/CardBody';
import AccountCircleOutlinedIcon from '@material-ui/icons/AccountCircleOutlined';
import { CardFooter } from '../components/Card/CardFooter';
import Fade from '@material-ui/core/Fade';
import { useStyles } from './styles';
import { db } from '../firebase';

const SignUpSchema = Yup.object().shape({
  firstName: Yup.string().min(2, 'Too Short!').max(50, 'Too Long!').required('Required'),
  lastName: Yup.string().min(2, 'Too Short!').max(50, 'Too Long!').required('Required'),
  email: Yup.string()
    .email('Invalid email')
    .required('Required')
    .matches(/.*aiesec\.net$/, 'Only aiesec emails are eligible to sign up'),
});

export const Signup = () => {
  const classes = useStyles();
  const { currentUser } = useContext(AuthContext);
  const { signup } = useAuth();
  const [error, setError] = useState(false);
  const [message, setErrorMessage] = useState('');
  const [showAlert, setShowAlert] = useState(false);
  const [loading, setLoading] = useState(false);
  const [checked, setChecked] = useState(true);
  return (
    <Grid container component="main" className={classes.container}>
      <Grid item xs={10} sm={8} md={6} lg={3}>
        <Fade in={checked}>
          <Card>
            <CardHeader>
              <Avatar className={classes.avatar}>
                <LockOutlinedIcon fontSize="small" />
              </Avatar>
              <Typography
                variant="h6"
                style={{
                  color: 'white',
                  fontFamily: '["Roboto", "Helvetica", "Arial", sans-serif]',
                  marginTop: '10px',
                }}
              >
                Sign Up
              </Typography>
            </CardHeader>
            <CardBody style={{ paddingTop: 0 }}>
              <Form
                className={classes.form}
                // validationSchema={SignUpSchema}
                initialValues={{
                  firstName: '',
                  lastName: '',
                  email: '',
                  password: '',
                  passwordConfirm: '',
                }}
                onSubmit={async (data) => {
                  if (data.password !== data.passwordConfirm) {
                    setError(true);
                    setErrorMessage('Password do not match. Try again!');
                  } else {
                    try {
                      setLoading(true);
                      await signup(data.email, data.password, data.firstName, data.lastName).then(
                        db.collection('profile').doc(currentUser.uid).set({
                          firstName: data.firstName,
                          lastName: data.lastName,
                          qualifications: [],
                          experiences: [],
                          activities: [],
                          contribution: [],
                          description: '',
                          positions: [],
                          current_position: 'Team Member',
                          function: '',
                          facebook: '',
                          instagram: '',
                          linkedIn: '',
                          role: 'viewer',
                          email: data.email,
                          dp_url: '',
                        })
                      );
                      // window.location.pathname = '/app';
                      setError(false);
                      setErrorMessage('Successfully Signed Up!');
                    } catch (error) {
                      console.log(currentUser.uid);
                      setErrorMessage('GG');
                      setError(true);
                    }
                    setLoading(false);
                  }
                  setShowAlert(true);
                }}
              >
                <Grid container spacing={1} alignItems="flex-end" className={classes.formContent}>
                  <Grid item xs={1}>
                    <AccountCircleOutlinedIcon color="action" />
                  </Grid>
                  <Grid item xs={10} className={classes.formInput}>
                    <FormInput
                      type="text"
                      label="First Name"
                      name="firstName"
                      variant="standard"
                      fullWidth={true}
                    />
                  </Grid>
                </Grid>
                <Grid container spacing={1} alignItems="flex-end" className={classes.formContent}>
                  <Grid item xs={1}>
                    <AccountCircleOutlinedIcon color="action" />
                  </Grid>
                  <Grid item xs={10} className={classes.formInput}>
                    <FormInput
                      type="text"
                      label="Last Name"
                      name="lastName"
                      variant="standard"
                      fullWidth={true}
                    />
                  </Grid>
                </Grid>
                <Grid container spacing={1} alignItems="flex-end" className={classes.formContent}>
                  <Grid item xs={1}>
                    <AccountCircleOutlinedIcon color="action" />
                  </Grid>
                  <Grid item xs={10} className={classes.formInput}>
                    <FormInput
                      type="email"
                      label="Email"
                      name="email"
                      variant="standard"
                      fullWidth={true}
                    />
                  </Grid>
                </Grid>
                <Grid container spacing={1} alignItems="flex-end" className={classes.formContent}>
                  <Grid item xs={1}>
                    <LockOutlinedIcon color="action" />
                  </Grid>
                  <Grid item xs={10} className={classes.formInput}>
                    <FormInput
                      type="password"
                      label="Password"
                      name="password"
                      variant="standard"
                      fullWidth={true}
                    />
                  </Grid>
                </Grid>
                <Grid container spacing={1} alignItems="flex-end" className={classes.formContent}>
                  <Grid item xs={1}>
                    <LockOutlinedIcon color="action" />
                  </Grid>
                  <Grid item xs={10} className={classes.formInput}>
                    <FormInput
                      type="password"
                      label="Confirm Password"
                      name="passwordConfirm"
                      variant="standard"
                      fullWidth={true}
                    />
                  </Grid>
                </Grid>
                {showAlert && <Alert severity={error ? 'error' : 'success'}>{message}</Alert>}
                <Button
                  disabled={loading}
                  type="submit"
                  fullWidth={true}
                  variant="contained"
                  color="primary"
                  className={classes.submit}
                >
                  Sign Up
                </Button>
              </Form>
            </CardBody>
            <CardFooter>
              <Grid container>
                <Grid item xs></Grid>
                <Grid item>
                  <Link href="/login" onClick={() => setChecked(false)}>
                    {'Sign In'}{' '}
                  </Link>
                </Grid>
              </Grid>
            </CardFooter>
          </Card>
        </Fade>
      </Grid>
    </Grid>
  );
};
